import { Autocomplete, Avatar, Button, IconButton, TextField } from '@mui/material';
import { SettingsField } from 'components/settings/SettingsField';
import { SettingsSection } from 'components/settings/SettingsSection';
import { TrackCover } from 'components/track/TrackCover';
import { useUser } from 'hooks/useUser';
import { t } from 'i18next';

export function Profile() {
  const userContext = useUser();

  return (
    <>
      <IconButton sx={{ p: 0 }}>
        <Avatar sx={{ width: 64, height: 64 }}>
          <TrackCover
            title={userContext.user?.displayName || userContext.user?.email || ''}
            cover={userContext.user?.photoURL || undefined}
            size="large"
          />
        </Avatar>
      </IconButton>
      <SettingsSection title={t('profile', 'Profile')}>
        <SettingsField label={t('profilePicture', 'Profile picture')}>
          <TextField />
        </SettingsField>
        <SettingsField label={t('name', 'Name')}>
          <TextField />
        </SettingsField>
        <SettingsField label={t('bio', 'Bio')}>
          <TextField multiline maxRows={3} />
        </SettingsField>
        <SettingsField label={t('country', 'Country')}>
          <Autocomplete
            options={[]}
            renderInput={(params) => <TextField {...params} label="Choose your country" />}
          />
        </SettingsField>
        <SettingsField label={t('genres', 'Genres')}>
          <TextField />
        </SettingsField>
      </SettingsSection>
      <SettingsSection title={t('dangerProfileSettings', 'Danger zone')}>
        <SettingsField label={t('deleteAccount', 'Delete account')}>
          <Button variant="contained" color="error">
            {t('deleteAccount', 'Delete account')}
          </Button>
        </SettingsField>
      </SettingsSection>
    </>
  );
}
